import { isOlderthan18 } from "src/helpers/addCase";
import * as yup from "yup";

const spaceCheckYupValidation = (val?: string) =>
  val ? !/^\s*$/.test(val) : false;

export const AddCaseSchema = yup.object({
  mos: yup.string().required(),
  submission_source: yup.string().required(),
  user_id: yup.number().required(),
  creator_name: yup.string().required(),
  doctor_firstlastname: yup.string(),
  doctor_fullname: yup.string(),
  patient_firstlastname: yup.string(),
  patient_fullname: yup.string(),
  patient_dob: yup.string(),
  practice_name: yup.string(),
  original_id: yup.number(),
  category: yup.string().required(),
  api_pa_approved: yup.boolean(),
  uploaded_documents: yup
    .array()
    .of(yup.mixed().required())
    .when(["api_pa_approved", "case_attributes"], {
      is: (
        api_pa_approved?: boolean,
        case_attributes?: { pa_approved: string },
      ) => {
        return process.env.REACT_APP_ENV === "staging"
          ? api_pa_approved ||
            (case_attributes && case_attributes.pa_approved?.length > 0)
            ? false
            : true
          : false;
      },
      then: (schema) =>
        schema
          .min(1, "Prescription document is required")
          .required("Prescription document is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  prescription_attributes: yup
    .object({
      condition: yup.string().required("Condition is required "),
      review_type: yup.string().required("Review Type is required"),
      drug_name: yup.string().required("Product is required"),
      frequency_of_use: yup.string().when("drug_name", {
        is: (prod?: string) => {
          // console.log('Product:', prod); // Log the product value
          return prod && prod === "Furoscix ReadyFlow Autoinjector";
        },
        then: (schema) => {
          // console.log('Zilretta selected, making injection_site required');
          return schema.required("Frequency is required.");
        },
        otherwise: (schema) => {
          // console.log('Other product selected, making injection_site required');
          return schema.notRequired();
        },
      }),
      other_frequency_of_use: yup.string().when(["drug_name", "frequency_of_use"], {
        is: (prod?: string,frequencyOfUse?: string) => {
         
          return prod && prod === "Furoscix ReadyFlow Autoinjector" && frequencyOfUse === "Other";
        },
        then: (schema) => {
         
          return schema.required("Other Frequency is required.");
        },
        otherwise: (schema) => {
          
          return schema.notRequired();
        },
      }),
      daily_dose: yup.string().when("drug_name", {
        is: (prod?: string) => {
          
          return prod && prod === "Furoscix ReadyFlow Autoinjector";
        },
        then: (schema) => {
         
          return schema.required("Daily Dose is required.");
        },
        otherwise: (schema) => {
         
          return schema.notRequired();
        },
      }),
      other_daily_dose: yup.string().when(["drug_name", "daily_dose"], {
        is: (prod?: string,dailyDose?: string) => {
         
          return prod && prod === "Furoscix ReadyFlow Autoinjector" && dailyDose === "Other";
        },
        then: (schema) => {
         
          return schema.required("Other Daily Dose is required.");
        },
        otherwise: (schema) => {
         
          return schema.notRequired();
        },
      }),
      diagnosis_code: yup
        .array()
        .of(yup.string().required(`Diagnosis code is required`))
        .min(1, `Diagnosis code is required`)
        .required(`Diagnosis code is required`),
      direction: yup
        .string()
        .max(255, "Direction should only be 255 characters long")
        .when({
          is: (val: string) => val && val.length > 0,
          then: (schema) =>
            schema.test(
              "whiteSpaceRemoval",
              "Direction should not contain only spaces",
              (val) => spaceCheckYupValidation(val),
            ),
        }),
      note: yup
        .string()
        .max(70, "Note should only be 70 characters long")
        .when({
          is: (val: string) => val && val.length > 0,
          then: (schema) =>
            schema.test(
              "whiteSpaceRemoval",
              "Note should not contain only spaces",
              (val) => spaceCheckYupValidation(val),
            ),
        }),
      injection_site: yup.string().required("Quantity is required"),
      scheduled_date_of_service: yup.string().when({
        is: (val?: string) => val && val.length > 0,
        then: (schema) =>
          schema.test(
            "dates-test",
            "Date of service should not be in past dates",
            (value?: string) => {
              const dob = new Date().toISOString().substring(0, 10);
              return value ? dob <= value : false;
            },
          ),
      }),
      refills_authorized: yup
        .number()
        .typeError("Enter a number between 0 and 12")
        .when({
          is: (val: string) => (val && typeof val === "number" ? true : false),
          then: (schema) =>
            schema
              .test(
                "whiteSpaceRemoval",
                "Enter a number between 0 and 12",
                (val) =>
                  val && spaceCheckYupValidation(val.toString()) ? true : false,
              )
              .test(
                "checkNumberInRange",
                "Enter a number between 0 and 12",
                (val) => {
                  if (val && typeof val === "number") {
                    if (!isNaN(val)) {
                      if (val > 0 && val < 13) return true;
                    }
                    return false;
                  } else {
                    return true;
                  }
                },
              ),
        }),
      written_date: yup.string().required(),
      // is_specialty_pharmacy_only: yup.boolean().required(),
      quickstart: yup.boolean().required(),
      cp_diuretics: yup
        .object({
          creatinine_clearance: yup.string(),
          eGFR: yup.string(),
          diuretics_tried: yup.object({
            furosemide: yup.boolean(),
            furosemide_props: yup.object({
              "20mg": yup.boolean(),
              "40mg": yup.boolean(),
              "80mg": yup.boolean(),
              result_of_use: yup.string(),
              hospitalization_date: yup.string(),
              other_dose: yup.boolean(),
              other_dosage_value: yup.string().when("other_dose", {
                is: (other_dose?: boolean) =>
                  typeof other_dose === "boolean" && other_dose === true
                    ? true
                    : false,
                then: (schema) =>
                  schema
                    .test("isRequired", "Dose is required", (dose?: string) => {
                      if (dose === "" || dose === "0") return false;
                      else return true;
                    })
                    .test("range", "Dose is invalid", (val?: string) => {
                      const numberedVal = Number(val);
                      if (!isNaN(numberedVal) && numberedVal > 0) return true;
                      else return false;
                    }),
                otherwise: (schema) => schema.notRequired(),
              }),
            }),
            torsemide: yup.boolean(),
            torsemide_props: yup.object({
              "5mg": yup.boolean(),
              "10mg": yup.boolean(),
              "20mg": yup.boolean(),
              "40mg": yup.boolean(),
              "60mg": yup.boolean(),
              "100mg": yup.boolean(),
              result_of_use: yup.string(),
              hospitalization_date: yup.string(),
              other_dose: yup.boolean(),
              other_dosage_value: yup.string().when("other_dose", {
                is: (other_dose?: boolean) =>
                  typeof other_dose === "boolean" && other_dose === true
                    ? true
                    : false,
                then: (schema) =>
                  schema
                    .test("isRequired", "Dose is required", (dose?: string) => {
                      if (dose === "" || dose === "0") return false;
                      else return true;
                    })
                    .test("range", "Dose is invalid", (val?: string) => {
                      const numberedVal = Number(val);
                      if (!isNaN(numberedVal) && numberedVal > 0) return true;
                      else return false;
                    }),
                otherwise: (schema) => schema.notRequired(),
              }),
            }),
            bumetanide: yup.boolean(),
            bumetanide_props: yup.object({
              "05mg": yup.boolean(),
              "1mg": yup.boolean(),
              "2mg": yup.boolean(),
              "3mg": yup.boolean(),
              "4mg": yup.boolean(),
              result_of_use: yup.string(),
              hospitalization_date: yup.string(),
              other_dose: yup.boolean(),
              other_dosage_value: yup.string().when("other_dose", {
                is: (other_dose?: boolean) =>
                  typeof other_dose === "boolean" && other_dose === true
                    ? true
                    : false,
                then: (schema) =>
                  schema
                    .test("isRequired", "Dose is required", (dose?: string) => {
                      if (dose === "" || dose === "0") return false;
                      else return true;
                    })
                    .test("range", "Dose is invalid", (val?: string) => {
                      const numberedVal = Number(val);
                      if (!isNaN(numberedVal) && numberedVal > 0) return true;
                      else return false;
                    }),
                otherwise: (schema) => schema.notRequired(),
              }),
            }),
          }),
        })
        .nullable()
        .required(),
    })
    .required(`prescription attributes are required`),

  patient_attributes: yup
    .object({})
    .when(
      "prescription_attributes",
      (prescription_attributes: { drug_name: string }[]) => {
        const drugName =
          prescription_attributes.length > 0
            ? prescription_attributes[0]?.drug_name
            : "";

        //:- if drug is iovera
        return yup
          .object({
            global_patient_id: yup
              .number()
              .default(0)
              .required(`Patient is required`),
            title: yup.string(),
            firstname: yup
              .string()
              .required("First name is required")
              .max(35, "First name should only be 35 characters long")
              .test(
                "whiteSpaceRemoval",
                "First name should not contain only spaces",
                (val) => spaceCheckYupValidation(val),
              ),
            middlename: yup
              .string()
              .max(35, "Middle name should only be 35 characters long")
              .when({
                is: (val: string) => val && val.length > 0,
                then: (schema) =>
                  schema.test(
                    "whiteSpaceRemoval",
                    "Middle name should not contain only spaces",
                    (val) => spaceCheckYupValidation(val),
                  ),
              }),
            lastname: yup
              .string()
              .required("Last name is required")
              .max(35, "Last name should only be 35 characters long")
              .test(
                "whiteSpaceRemoval",
                "Last name should not contain only spaces",
                (val) => spaceCheckYupValidation(val),
              ),
            dob: yup
              .string()
              .required("DOB is required")
              .test(
                "dates-test",
                "Date of Birth should be less than present date",
                (value: string) => {
                  const dob = new Date().toISOString().substring(0, 10);
                  return dob >= value;
                },
              ),
           
            weight: yup.string().when("dob", {
              is: (dob?: string) => {
                

                const isUnder18 = Boolean(dob && !isOlderthan18(dob));
                const isFuroscix =
                  drugName === "Furoscix On-Body Infusor";

                return isUnder18 && isFuroscix;
              },

              then: (schema) =>
                schema
                  .test(
                    "isEmptyWeight",
                    "Weight is required for patients under 18 years",
                    (weight?: string) => {
                      if (
                        weight &&
                        (weight.endsWith("kg") || weight.endsWith("lb"))
                      ) {
                        const parsedWeight = weight.replace(/(kg|lb)$/, "");
                        return parsedWeight.length > 0;
                      }

                      return false;
                    },
                  )
                  .test(
                    "isValidWeight",
                    "Weight is invalid",
                    (weight?: string) => {
                      const weightValue = weight?.replace(/(kg|lb)$/, "");

                      if (!weightValue || isNaN(Number(weightValue))) {
                        return false;
                      }

                      return (
                        Number(weightValue) > 0 &&
                        /^\d+(\.\d{1})?$/.test(weightValue)
                      );
                    },
                  ),

              otherwise: (schema) => schema.notRequired(),
            }),
            gender: yup.string().required("Gender is required"),
            caregiver_name: yup.string().when("dob", {
             is: (dob?: string) => {
                

                const isUnder18 = Boolean(dob && !isOlderthan18(dob));
                const isFuroscix =
                  drugName === "Furoscix On-Body Infusor";

                return isUnder18 && isFuroscix;
              },
              

                  then: (schema) =>
                    schema.required("Parent/Guardian name is required"),
              

              otherwise: (schema) => schema.notRequired(),
            }),
          
            caregiver_phone_number: yup
              .string()

              .when("dob", {
               is: (dob?: string) => {
               

                const isUnder18 = Boolean(dob && !isOlderthan18(dob));
                const isFuroscix =
                  drugName === "Furoscix On-Body Infusor";

                return isUnder18 && isFuroscix;
              },then: (schema) =>
                      schema
                        .required("Parent/Guardian phone number is required")
                        .test(
                          "range",
                          "Phone number invalid",
                          (val?: string) => {
                            if (val && val.length > 0) {
                              const numberedVal = Number(val);

                              return (
                                !isNaN(numberedVal) &&
                                numberedVal > 2000000000 &&
                                numberedVal < 9999999999
                              );
                            }

                            return true;
                          },
                        ),
                otherwise: (schema) => schema.notRequired(),
              }),
            best_time_to_contact: yup.string(),

            phone_numbers: yup
              .array()
              .of(
                yup.object({
                  phone_type: yup.string().required("Phone type is required"),
                  number: yup
                    .string()
                    .required(`Phone number is required`)
                    .min(10, `Phone number invalid`)
                    .max(10, `Phone number invalid`)
                    .test("range", "Phone number invalid", (val) => {
                      const numberedVal = Number(val);
                      if (!isNaN(numberedVal)) {
                        if (
                          numberedVal > 2000000000 &&
                          numberedVal < 9999999999
                        )
                          return true;
                      }
                      return false;
                    }),
                  is_preferred: yup
                    .boolean()
                    .default(false)
                    .required("Preferred phone is required"),
                  is_ok_to_leave_message: yup
                    .boolean()
                    .default(false)
                    .required("OK to leave message is required"),
                  id: yup.number().required().nullable(),
                }),
              )
              .min(1, "At least one phone number is required for patient")
              .required(`at least one phone number is required for patient`),

            address: yup
              .object({
                street: yup
                  .string()
                  .required(`Street is required`)
                  .test(
                    "whiteSpaceRemoval",
                    "Street should not contain only spaces",
                    (val) => spaceCheckYupValidation(val),
                  ),
                suite: yup.string().when({
                  is: (val: string) => val && val.length > 0,
                  then: (schema) =>
                    schema.test(
                      "whiteSpaceRemoval",
                      "Suite should not contain only spaces",
                      (val) => spaceCheckYupValidation(val),
                    ),
                }),
                city: yup
                  .string()
                  .required(`City is required`)
                  .test(
                    "whiteSpaceRemoval",
                    "City should not contain only spaces",
                    (val) => spaceCheckYupValidation(val),
                  ),
                state: yup.string().required(`State is required`),
                zip: yup
                  .string()
                  .required(`Zip is required`)
                  .max(9, "Zip should not be more than 9 digits")
                  .test(
                    "containAllDigits",
                    "Zip should only contain digits",
                    (val) => (val ? /^\d+$/.test(val) : false),
                  ),
                address_name: yup.string().required(`Address type is required`),
              })
              .required(`Address for patient information is required`),
          })
          .required(`Patient details are required`);
      },
    ),

  doctor_attributes: yup.object({
    practice_id: yup.number().required(`Practice is required`),
    global_doctor_id: yup
      .number()
      .required(`Administrative prescriber is required`),
  }),

  // shipments_attributes: yup.array().of(
  //   yup.object({
  //     ship_to_street: yup.string(),
  //     ship_to_suite: yup.string(),
  //     ship_to_city: yup.string(),
  //     ship_to_state: yup.string(),
  //     ship_to_zip: yup.string(),
  //   }),
  // )
  // //.required(`shipment attributes are required`)
  // ,

  insurances_attributes: yup
    .array()
    .of(
      yup.object({
        insurance_name: yup
          .string()
          .required(`Insurance Name is required`)
          .test(
            "whiteSpaceRemoval",
            "Insurance Name should not contain only spaces",
            (val) => spaceCheckYupValidation(val),
          ),
        relation_to_patient: yup
          .string()
          .required(`Relation to patient is required`),
        relation_firstname: yup
          .string()
          .max(35, "First name should only be 35 characters long")
          .when("relation_to_patient", {
            is: (relation: string) => relation && relation !== "self",
            then: (schema) => schema.required("First name is required"),
          })
          .when({
            is: (val: string) => val && val.length > 0,
            then: (schema) =>
              schema.test(
                "whiteSpaceRemoval",
                "First name should not contain only spaces",
                (val) => spaceCheckYupValidation(val),
              ),
          }),
        relation_middlename: yup
          .string()
          .max(35, "Middle name should only be 35 characters long")
          .when({
            is: (val: string) => val && val.length > 0,
            then: (schema) =>
              schema.test(
                "whiteSpaceRemoval",
                "Middle name should not contain only spaces",
                (val) => spaceCheckYupValidation(val),
              ),
          }),
        relation_lastname: yup
          .string()
          .max(35, "Last name should only be 35 characters long")
          .when("relation_to_patient", {
            is: (relation: string) => relation && relation !== "self",
            then: (schema) => schema.required("Last name is required"),
          })
          .when({
            is: (val: string) => val && val.length > 0,
            then: (schema) =>
              schema.test(
                "whiteSpaceRemoval",
                "Last name should not contain only spaces",
                (val) => spaceCheckYupValidation(val),
              ),
          }),

        policy: yup
          .string()
          .required(`Member id is required`)
          .test(
            "whiteSpaceRemoval",
            "Member id should not contain only spaces",
            (val) => spaceCheckYupValidation(val),
          ),
        group_number: yup
          .string()
          .max(45, "Group should only be 45 characters long")
          .when({
            is: (val: string) => val && val.length > 0,
            then: (schema) =>
              schema.test(
                "whiteSpaceRemoval",
                "Group should not contain only spaces",
                (val) => spaceCheckYupValidation(val),
              ),
          }),
        insurance_number: yup.string().when({
          is: (val: string) => val && val.length > 0,
          then: (schema) =>
            schema
              .min(10, `Insurance phone number invalid`)
              .max(10, `Insurance phone number invalid`)
              .test("range", "Insurance phone number invalid", (val) => {
                const numberedVal = Number(val);
                if (!isNaN(numberedVal)) {
                  if (numberedVal > 2000000000 && numberedVal < 9999999999)
                    return true;
                }
                return false;
              }),
        }),

        member_id: yup
          .string()
          .max(55, "Rx member id should only be 55 characters long")
          .when({
            is: (val: string) => val && val.length > 0,
            then: (schema) =>
              schema.test(
                "whiteSpaceRemoval",
                "Rx member id should not contain only spaces",
                (val) => spaceCheckYupValidation(val),
              ),
          }),
        bin: yup.string().when({
          is: (val: string) => val && val.length > 0,
          then: (schema) =>
            schema
              .max(6, "bin should be 6 digits long")
              .test(
                "containAllDigits",
                "bin should only contain digits",
                (val) => spaceCheckYupValidation(val),
              ),
        }),
        pcn: yup
          .string()
          .max(45, "PCN should only be 45 characters long")
          .when({
            is: (val: string) => val && val.length > 0,
            then: (schema) =>
              schema.test(
                "whiteSpaceRemoval",
                "PCN should not contain only spaces",
                (val) => spaceCheckYupValidation(val),
              ),
          }),
        rx_group: yup
          .string()
          .max(45, "Rx group should only be 45 characters long")
          .when({
            is: (val: string) => val && val.length > 0,
            then: (schema) =>
              schema.test(
                "whiteSpaceRemoval",
                "Rx group should not contain only spaces",
                (val) => spaceCheckYupValidation(val),
              ),
          }),

        is_primary_insurance: yup.boolean().required(),
        insurance_priority: yup.number().required(),
        global_insurance_id: yup.string().required().nullable(),
      }),
    )
    .min(1, "At least one insurance information is required")
    .required("Patient insurance information is required"),

  case_attributes: yup.object({
    // ship_to: yup.string(),
    pa_approved: yup.string(),
    pa_approved_date: yup.string().when(["pa_approved"], {
      is: (pa_approved?: string) => {
        return pa_approved &&
          pa_approved === "pa_approved" &&
          process.env.REACT_APP_ENV === "staging"
          ? true
          : false;
      },
      then: (schema) => schema.required("Approval end date is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    //.test("whiteSpaceRemoval", "Site of Care should not contain only spaces", (val) => spaceCheckYupValidation(val)),
  }),
  //.required(`Site of care is required`),
});
